import React from 'react';
import DOMPurify from 'dompurify';
import { Experience as ExperienceType } from '../../types';
import './Experience.css';

interface Props {
    experience: ExperienceType[];
}

const Experience: React.FC<Props> = ({ experience }) => (
    <ol className="timeline" aria-label="Work experience timeline">
        {experience.map((job, index) => (
            <li key={index} className="timeline-item">
                <div className="timeline-dot" aria-hidden="true" />

                <article className="experience-card" aria-label={`${job.job_title} at ${job.company}`}>
                    <div className="exp-meta">
                        <span className="exp-duration">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                            </svg>
                            {job.duration}
                        </span>
                        <span className="exp-location">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                            </svg>
                            {job.location}
                        </span>
                    </div>

                    <h3 className="exp-title">{job.job_title}</h3>
                    <p className="exp-company">{job.company}</p>

                    <div
                        className="exp-description"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.description) }}
                    />
                </article>
            </li>
        ))}
    </ol>
);

export default React.memo(Experience);
